import React, { useEffect, useState } from "react";
import home from "./Home2.module.css";
import { Link, useHistory } from "react-router-dom";
import {
  getsuperyDiscountApi,
  getfoodDiscountApi,
} from "../../Api/ClientServices";
import PointSpreadLoading from "react-loadingg/lib/PointSpreadLoading";
import { getUserInfo, LogoutUser } from "../../Api/BarestServices";
import SearchHome from "../../Component/SearchHome/SearchHome";
import FoodDiscountSliderHome from "../../Component/FoodDiscountSliderHome/FoodDiscountSliderHome";
import SuperyDiscountSliderHome from "../../Component/SuperyDiscountSliderHome/SuperyDiscountSliderHome";
import { errorToast } from "../../Toast/Toast";

const Home = () => {
  const [foodSlider, setfoodSlider] = useState([]);
  const [superySlider, setSuperySlider] = useState([]);

  let ref = new URLSearchParams(window.location.search).get("ref");

  useEffect(() => {
    getfoodDiscount();
    getSuperyDiscount();
    getUser();
    if(ref){
      localStorage.setItem("ref", ref);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const getfoodDiscount = async () => {
    getfoodDiscountApi((succ,res)=>{
      if(succ){
        if(res.status===1){
          errorToast(res.message)
        }else{
          setfoodSlider(res.products);
        }
      }else{
        console.error(res)
      }
    })
  };
  const getSuperyDiscount = async () => {
    getsuperyDiscountApi((succ,res)=>{
      if(succ){
        if(res.status===1){
          errorToast(res.message)
        }else{
          setSuperySlider(res.products);
        }
      }else{
        console.error(res)
      }
    })
  };
  const LogoutHandler = () => {
    let info = {
      logout: "",
    };
    LogoutUser(info, (succ) => {
      return;
    });
  };
  let history = useHistory();
  const getUser = async () => {
    getUserInfo((succ,res)=>{
      if(succ){
        if(res.status===0||res.status===-2){
          console.warn('کاربر وارد نشده!')
        }else{
          if (res.status === 0) {
            localStorage.removeItem("JwtTokens");
          } else if (localStorage.getItem("JwtTokens")) {
            if (res.status === -2) {
              LogoutHandler();
              localStorage.removeItem("JwtTokens");
              localStorage.clear();
              history.push("/login");
            }
          } else {
          }
        }
      }else{
        console.error(res)
      }
    })
  };

  let loadDiscountFood = null;
  if (foodSlider === undefined) {
    loadDiscountFood = (
      <div className={home.loading2Test}>
        <PointSpreadLoading color={"#ab0c59"} size={"small"} />
      </div>
    );
  } else {
    loadDiscountFood = <FoodDiscountSliderHome data={foodSlider} />;
  }

  let loadDiscountSupery = null;
  if (superySlider === undefined) {
    loadDiscountSupery = (
      <div className={home.loading2Test}>
        <PointSpreadLoading color={"#ab0c59"} size={"small"} />
      </div>
    );
  } else {
    loadDiscountSupery = <SuperyDiscountSliderHome data={superySlider} />;
  }
  return (
    <div className={home.pageHolder}>
      <div className={home.ScrollHolder}>
        <h2 className={home.pageTitle}>بَرِست در خدمت شما</h2>
        <SearchHome />
        <div className={home.khadamat}>
          <div className={home.firstColumnHolder}>
            <Link to="/Supermarket">
              <div className={`${home.khadamatPart} ${home.supermarket}`}>
                <div className={home.picPart}>
                  <img
                    src={"/Assets/Images/HomePage/supermarket.png"}
                    alt="فروشگاه"
                  />
                </div>
                <h3>فروشگاه</h3>
              </div>
            </Link>
            <Link to="/Restaurants">
              <div className={`${home.khadamatPart} ${home.resturant}`}>
                <div className={home.picPart}>
                  <img src={"/Assets/Images/HomePage/rest.png"} alt="رستوران" />
                </div>
                <h3>رستوران و کافه</h3>
              </div>
            </Link>
          </div>
          <div className={home.firstColumnHolder}>
            {/* <Link to="/requestdeliver">
            <div className={`${home.khadamatPart} ${home.deliver}`}>
            <div className={home.picPart}>
            <img src={"/Assets/Images/HomePage/deliver.png"} alt=" " />
              </div>
              <h3>درخواست پیک</h3>
              </div>
            </Link>  */}
            <Link to="/deliveryrequest">
              <div className={`${home.khadamatPart} ${home.deliver}`}>
                <div className={home.picPart}>
                  <img src={"/Assets/Images/HomePage/peyk2.png"} alt=" " />
                </div>
                <h3>درخواست پیک</h3>
              </div>
            </Link>
            {/* <Link to="/current"> */}
            <Link to="/taxireqlist">
              <div className={`${home.khadamatPart} ${home.taxi}`}>
                <div className={home.picPart}>
                  <img src={"/Assets/Images/HomePage/1.png"} alt=" " />
                </div>
                <h3>تاکسی</h3>
              </div> 
            </Link>
            {/* <Link to="/comingsoon">
              <div className={`${home.khadamatPart} ${home.taxi}`}>
                <div className={home.picPart}>
                  <img src={"/Assets/Images/HomePage/1.png"} alt=" " />
                </div>
                <h3>تاکسی</h3>
              </div> 
            </Link> */}
          </div>
        </div>
        {/* <div className={home.Components}> 
          <div className={home.Title}>
            <Link to={"/morediscountfood"}>
              <h3 className={home.leftTitle}> بیشتر</h3>
            </Link>
            <h3 className={home.RightTitle}>تخفیف رستوران ها </h3>
          </div>
          <div className={home.Items}>{loadDiscountFood}</div>
        </div>
        <div className={home.Components}>
          <div className={home.Title}>
            <Link to={"/morediscountsupery"}>
              <h3 className={home.leftTitle}> بیشتر</h3>
            </Link>
            <h3 className={home.RightTitle}>تخفیف فروشگاه ها </h3>
          </div>
          <div className={home.Items}>{loadDiscountSupery}</div>
        </div> */}
      </div>
      {/* <div className={home.footer}>
        <Footer />
      </div> */}
    </div>
  );
};

export default Home;
